import { useEventMetadataStore } from './event-metadata';

export function useIsClearedEvent() {
    const eventInfo = useEventMetadataStore()?.state?.metadata;
    return eventInfo?.eventId ? !eventInfo?.isActive : false;
}
